module.exports = __webpack_public_path__ + "img/nomination_form.39b3797c.svg";